import { create } from "zustand";

type StudentModalData = { id: number };

type StudentModalStore = {
  isOpen: boolean;
  data: StudentModalData | null;
  openModal: (data: StudentModalData) => void;
  closeModal: () => void;
};

export const useStudentModalStore = create<StudentModalStore>((set) => ({
  isOpen: false,
  data: null,
  openModal: (data) => set({ isOpen: true, data }),
  closeModal: () => set({ isOpen: false, data: null }),
}));
